import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import { ReactNode } from "react";
export function InfoBox(t0) {
  const $ = _c(7);
  const {
    children,
    bgColor: t1,
    heading,
    className,
    collapse,
    buttonTitle
  } = t0;
  const bgColor = t1 === undefined ? "bg-babyBlue" : t1;
  let t2;
  if ($[0] !== bgColor || $[1] !== buttonTitle || $[2] !== children || $[3] !== className || $[4] !== collapse || $[5] !== heading) {
    t2 = <>{collapse ? <div className={cn(className)}>{heading}<div className="relative"><div className={cn("flex flex-col rounded-2xl", bgColor)}><input type="checkbox" id="toggle" className="peer hidden" /><label htmlFor="toggle" className="matchbus orange absolute -bottom-6 left-1/2 z-20 flex -translate-x-1/2 items-center p-3">{buttonTitle}</label><div className="max-h-48 overflow-hidden pb-16 transition-[max-height] duration-500 ease-in-out peer-checked:max-h-max md:px-8 md:peer-checked:max-h-screen">{children}</div><div className="relative w-full"><div className="rounded-b-2xl absolute bottom-0 left-1/2 z-10 box-border h-32 w-[93%] -translate-x-1/2 bg-gradient-to-b from-transparent to-babyBlue md:w-full" /></div></div></div></div> : <div className={className}>{heading}<div className={cn("flex flex-col rounded-2xl", bgColor)}><div className="h-full p-6">{children}</div></div></div>}</>;
    $[0] = bgColor;
    $[1] = buttonTitle;
    $[2] = children;
    $[3] = className;
    $[4] = collapse;
    $[5] = heading;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}